import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

/**
 * Resets all Recoil atoms/selectors used by the Manage Seating flow
 * and related checkout seating state so other pages don't assume
 * the manage seating context is still active.
 */
export const resetManageSeatingState = (): void => {
  // Seating map and selection state
  updateRecoilState("seatSelectorOpenAtom", false);
  updateRecoilState("selectedSeatsAtom", []);
  updateRecoilState("confirmedSeatsAtom", []);
  updateRecoilState("originalSeatsAtom", []);
  updateRecoilState("placeMapResponseAtom", null);
  updateRecoilState("coachLayoutResponseAtom", null);
  updateRecoilState("floorPlanIconsResponseAtom", null);
  updateRecoilState("seatServiceClassAtom", []);
  updateRecoilState("seatTravelClassAtom", []);
  updateRecoilState("selectedCoachAtom", "");
  updateRecoilState("unavailableSeatsAtom", []);
  updateRecoilState("initiallyAvailableSeatsAtom", null);
  updateRecoilState("passengerSeatCursorAtom", []);

  // The add-on toast keys, raised at CONFIRM time by
  // PersistAddonsOnConfirmAction — before any payment. Nothing settled on the
  // way in here, so a key still sitting there announces "Add-ons Added" for
  // add-ons the customer never paid for the next time they open that booking.
  // GetBookingDetailDataAction used to swallow that silently because its toasts
  // were gated on isManageSeatingAtom; they no longer are, so the stranded key
  // has to be cleared at the source.
  //
  // Covers the three IN-APP teardowns that route through this helper: the
  // Topbar nav-away, the /bookings ManageSeating.Flow.Close, and re-entry.
  // NOT every abandonment: browser-Back from /checkout to the details page
  // reaches neither this helper nor that event, so a confirm-time key still
  // survives there. That gap is unchanged by this branch — the old
  // isManageSeating gate toasted on that route too, since the atom is still
  // true after a Back-button abandonment.
  //
  // Deliberately NOT on the paying path: every settlement route (MPGS 200 and
  // 409, the zero-amount 204, 2xx-without-session.id, the non-gateway branch)
  // reaches the details page without passing through here, so the real
  // post-payment toast survives.
  try {
    sessionStorage.removeItem("needToShowAddedAddons");
    sessionStorage.removeItem("needToShowRemovedAddons");
  } catch {
    // Private-mode / SSR: nothing to clear.
  }

  // Flags and context toggles
  updateRecoilState("isManageSeatingAtom", false);
  updateRecoilState("isHyperFastStateAtom", false);
  //updateRecoilState("isQuickExchangeStateAtom", false);

  // Input contexts used during manage seating
  updateRecoilState("displayPassengerDataAtom", null);
  updateRecoilState("selectedTripsDataAtom", null);

  // Payment summary will be recomputed by target screens (e.g., Booking Details)
  updateRecoilState("checkoutPaymentSummaryAtom", null);

  updateRecoilState("manageSeatingBaselineAddonsLegPassengerAtom", {});
};


